var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M92.298 101.838v19.081h95.404v-19.081h19.081c15.78 0 28.622 12.842 28.622 28.622v85.864h-28.622v38.162H73.217v-38.162H44.595V130.46c0-15.78 12.842-28.622 28.622-28.622zm95.404 95.405H92.298v38.162h95.404zm19.081-76.324V140H73.217v-19.081c-5.257 0-9.541 4.274-9.541 9.54v66.784h9.54v-19.081h133.567v19.081h9.541V130.46c0-5.267-4.284-9.541-9.54-9.541m-19.08 28.621c5.266 0 9.54 4.275 9.54 9.541 0 5.276-4.274 9.54-9.54 9.54s-9.541-4.264-9.541-9.54c0-5.266 4.274-9.54 9.54-9.54m19.08-114.485v57.243h-19.08V54.136H92.297v38.162H73.217V35.055z"
})));
export default SvgPrint;